var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.classes,attrs:{"src":_vm.item.Image.File.Url,"alt":_vm.item.Image.Description,"title":_vm.item.Image.Description,"data-contentful-image":_vm.item.Id}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71060742","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./WebResources/vue/shared/components/contentful/ContentfulImage.vue
// module id = 449
// module chunks = 0 1 2 3 4 5 6 7 9 10 11 12 13 14 15 16 17 18 19 20 21 22